import { createClientRpc } from '@tanstack/react-start/client-rpc';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { useTranslation } from "@/lib/paraglide-react";
export const saveStateFile = createServerFn({
  method: "GET"
}).handler(createClientRpc("ee123d1f50489559e862d08788a6d6dfb9919a42173e99ea5a9b52e67d31ea0f"));
export const getEpicEnv = createServerFn({
  method: "GET"
}).handler(createClientRpc("ea669a7a0822ee829b9fe406bd89f37f8abf3127d04ebaf063d6ab21f9475920"));
export const Route = createFileRoute("/auth/login")({
  component: () => {
    const {
      t
    } = useTranslation();
    return <div>{t("auth.login.placeholder")}</div>;
  },
  beforeLoad: async () => {
    const state = await saveStateFile({
      data: undefined
    });
    const {
      clientId,
      redirectUri
    } = await getEpicEnv({
      data: undefined
    });
    const epicUrl = new URL("https://www.epicgames.com/id/authorize");
    epicUrl.searchParams.set("client_id", clientId);
    epicUrl.searchParams.set("response_type", "code");
    epicUrl.searchParams.set("scope", "basic_profile");
    epicUrl.searchParams.set("redirect_uri", redirectUri);
    epicUrl.searchParams.set("state", state);
    throw redirect({
      href: epicUrl.toString()
    });
  }
});